export const ETHNIC_GROUP_CATEGORY_MODEL = "ethnic-group-category";

const ethnicGroupCategoryModel = {
  name: ""
};

export default ethnicGroupCategoryModel;
